import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import localStorage from 'local-storage';
import moment from 'moment';
import * as CurrencyFormat from 'react-currency-format';
import {Button} from 'react-bootstrap';


class AccountReturns extends Component {
    constructor(props) {
        super(props);
        this.state = {
            checked: "percentages",
            accountReturns: []
        }
    }

    static getDerivedStateFromProps(props, state) {
        let accountReturns = [];
        props.accountReturns ? props.accountReturns.map(accountReturn => accountReturns.push(accountReturn)) : accountReturns = [];

        return {
            accountReturns: accountReturns
        }
    }

    handleShowIn(e) {
        this.setState({ checked: e.target.id })

    }
    render() {
        const { t } = this.props;
        const pageType="account";
        return (
            this.props.isAccountReturnsEmpty ? <div style={{ marginTop: "15px" }} className="tabMessage">No Account Returns</div> :
            !this.state.accountReturns || this.state.accountReturns.length == 0 ? <div style={{ marginTop: "15px" }} className="tabMessage">{t('fetching') + " " + t('account') + " " + t('returns')}</div>
                :
                <div style={{ marginTop: "20px" }}>
                    <table style={{ width: "100%" }}>
                        <thead>
                            <th style={{ textAlign: "left", fontSize: "14.6667px", fontFamily: "Roboto, sans-serif" }}>{t('balanceDetails:netInvestments')}{moment(localStorage.startDate).format('DD MMMM YYYY')}</th>
                            <th style={{ textAlign: "right", fontSize: "14.6667px", fontFamily: "Roboto, sans-serif" }}>{t('balanceDetails:showIn')}
                                <input type="radio" id="percentages" checked={this.state.checked === "percentages"} onClick={e => this.handleShowIn(e)} />{t('balanceDetails:percentages')}(%)
                                <input type="radio" id="dollars" checked={this.state.checked === "dollars"} onClick={e => this.handleShowIn(e)} />{t('balanceDetails:dollars')}($)
                            </th>
                        </thead>
                    </table>

                    <table className="table-responsive superlifeLegacyPlan" style={{ marginLeft: "-1px", marginRight: "1px" }}>
                        <col></col>
                        {
                            this.props.products && this.props.products.map(product => product.scheme === "SLI"
                                && product.accounts && <colgroup span={product.accounts.length}></colgroup>)
                        }
                        <thead>
                            <tr>
                                <th style={{ height: 30 }} rowSpan="3"></th>
                                {
                                    !this.props.products ? ""
                                        : this.props.products.map(product =>
                                            <th colSpan={product.accounts.length} scope="colgroup">{product.schemeName}</th>)
                                }
                                <th>{t('adviserHomePage:total')}</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                this.state.accountReturns.map((accountReturn, index) => 
                                    <tr key={index}>
                                        <td style={{ textAlign: "left" }}>{accountReturn.description}</td>
                                        {
                                            accountReturn.accounts.map(account => 
                                                <td key={index}>{this.state.checked === "dollars" ?
                                                account.amount ?
                                                    <CurrencyFormat value={Number(account.amount).toFixed(2)}
                                                        displayType={'text'}
                                                        thousandSeparator={true}
                                                        prefix={'$'} /> : "n/a" :
                                                        account.percentage ? account.percentage : "n/a"}</td>
                                            )
                                        }
                                        <td>{this.state.checked === "dollars" ? accountReturn.totalAmt ?
                                            <CurrencyFormat value={Number(accountReturn.totalAmt).toFixed(2)}
                                                displayType={'text'}
                                                thousandSeparator={true}
                                                prefix={'$'} /> : "n/a" :
                                                accountReturn.totalPct ? accountReturn.totalPct : "n/a"}
                                        </td>                                    
                                    </tr>
                                )
                                // this.props.accountReturns.map((accountReturn, index) =>
                                //     <tr key={index}>
                                //         <td style={{ textAlign: "left" }}>{accountReturn.description}</td>
                                //         {
                                //             accountReturn.accounts.filter(account =>
                                //                 account.account === "Member").map(acc =>
                                //                     <td>{this.state.checked === "dollars" ?
                                //                         acc.amount ?
                                //                             <CurrencyFormat value={Number(acc.amount).toFixed(2)}
                                //                                 displayType={'text'}
                                //                                 thousandSeparator={true}
                                //                                 prefix={'$'} /> : "n/a" :
                                //                         acc.percentage ? Number(acc.percentage).toFixed(2) + "%" : "n/a"}</td>)
                                //         }
                                //         {
                                //             accountReturn.accounts.filter(account =>
                                //                 account.account === "Employer").map(acc =>
                                //                     <td>{this.state.checked === "dollars" ?
                                //                         acc.amount ?
                                //                             <CurrencyFormat value={Number(acc.amount).toFixed(2)}
                                //                                 displayType={'text'}
                                //                                 thousandSeparator={true}
                                //                                 prefix={'$'} /> : "n/a" :
                                //                         acc.percentage ? Number(acc.percentage).toFixed(2) + "%" : "n/a"}</td>)
                                //         }
                                //         {
                                //             accountReturn.accounts.filter(account =>
                                //                 account.account === "Voluntary").map(acc =>
                                //                     <td>{this.state.checked === "dollars" ?
                                //                         acc.amount ?
                                //                             <CurrencyFormat value={Number(acc.amount).toFixed(2)}
                                //                                 displayType={'text'}
                                //                                 thousandSeparator={true}
                                //                                 prefix={'$'} /> : "n/a" :
                                //                         acc.percentage ? Number(acc.percentage).toFixed(2) + "%" : "n/a"}</td>)
                                //         }
                                //         {
                                //             accountReturn.accounts.filter(account =>
                                //                 account.account === "KiwiSaver").map(acc =>
                                //                     <td>{this.state.checked === "dollars" ?
                                //                         acc.amount ?
                                //                             <CurrencyFormat value={Number(acc.amount).toFixed(2)}
                                //                                 displayType={'text'}
                                //                                 thousandSeparator={true}
                                //                                 prefix={'$'} /> : "n/a" :
                                //                         acc.percentage ? Number(acc.percentage).toFixed(2) + "%" : "n/a"}</td>)
                                //         }
                                //         {
                                //             accountReturn.accounts.filter(account =>
                                //                 account.account === "UK pension transfer").map(acc =>
                                //                     <td>{this.state.checked === "dollars" ?
                                //                         acc.amount ?
                                //                             <CurrencyFormat value={Number(acc.amount).toFixed(2)}
                                //                                 displayType={'text'}
                                //                                 thousandSeparator={true}
                                //                                 prefix={'$'} /> : "n/a" :
                                //                         acc.percentage ? Number(acc.percentage).toFixed(2) + "%" : "n/a"}</td>)
                                //         }
                                //         <td>{this.state.checked === "dollars" ? accountReturn.totalAmt ?
                                //             <CurrencyFormat value={Number(accountReturn.totalAmt).toFixed(2)}
                                //                 displayType={'text'}
                                //                 thousandSeparator={true}
                                //                 prefix={'$'} /> : "n/a" :
                                //             accountReturn.totalPct ? Number(accountReturn.totalPct).toFixed(2) + "%" : "n/a"}</td>
                                //     </tr>)
                                }
                        </tbody>
                    </table>
                    <table>
                        <tbody>
                            <tr style={{ fontSize: "12px" }}>{t("AccountBalance:ReturnsAreOnly", {pageType})}</tr>
                        </tbody>
                    </table>
                    <table style={{ marginTop: "10px" }}>
                    <tbody>
                        <tr style={{ fontSize: "12px" }}>{t("AccountBalance:TheInvestmentReturns")}
                            <span id="ViewReturnDetails">
                                To view more details 
                                <Button style={{ color: "#50833C", background: 'none', border: 'none', fontWeight: 'bold', cursor: 'pointer'}}
                                    onClick={e => this._showNote(e)}>click here</Button>
                            </span>
                        </tr>
                    </tbody>
                    </table>
                    <table style={{ marginTop: "10px" }}>
                        <tbody>
                            <tr style={{ fontSize: "12px" }}>{t("AccountBalance:Remember")}</tr>
                        </tbody>
                    </table>
                    {/* <table style={{ marginTop: "10px" }}>
                        <tbody>
                            <tr style={{ fontSize: "12px" }}>{t("AccountBalance:ToViewByPool")}<Link to="/" style={{ color: "#50833C" }}>{t('clickHere')}</Link></tr>
                        </tbody>
                    </table>
                    <table style={{ marginTop: "10px", paddingBottom: "25px" }}>
                        <tbody>
                            <tr style={{ fontSize: "12px" }}>{t("AccountBalance:ToViewYourStatements")}<Link to="/" style={{ color: "#50833C" }}>{t('clickHere')}</Link></tr>
                        </tbody>
                    </table> */}

                </div>
        )
    }
}

export default withTranslation()(AccountReturns);